import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules'
import 'swiper/css';
import SectionHeading from '../../Common/SectionHeading';

import Link from 'next/link';
import Image from 'next/image';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/autoplay';

const CaseStudiesSection = ({data=null}) => {
    return (
        <>
            {(data) &&
                <>
                    {data?.map((item,index) => (
                        <section key={index} className='flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10'>
                            <SectionHeading
                                title={item?.title}
                            />
                            <div className=''>
                                <Swiper
                                    modules={[Navigation, Scrollbar, A11y, Autoplay]}
                                    autoplay={{ delay: 5000 }}
                                    loop={true}
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 1,
                                            spaceBetween: 20,
                                        },
                                        768: {
                                            slidesPerView: 1,
                                            spaceBetween: 40,
                                        },
                                        1024: {
                                            slidesPerView: 2,
                                            spaceBetween: 50,
                                        },
                                    }}>
                                    {item?.listItem?.map((item, index) => (
                                        <SwiperSlide key={index}>
                                            <>
                                            <div className="grid grid-cols-12 gap-4">
                                                <div className="col-span-12 lg:col-span-4 group">
                                                    <Link className="relative group" href={process.env.APP_URL+item?.link}>
                                                        <Image priority={true}
                                                            width={2000}
                                                            height={2000}
                                                            className="lg:w-full"
                                                            alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                                                            src={process.env.IMG_CDN+item?.imageSrc}
                                                        />
                                                        <div className="group-hover:before:absolute group-hover:before:left-0 group-hover:before:top-0 group-hover:before:right-0 group-hover:before:bottom-0 group-hover:before:bg-opacity-60 group-hover:before:bg-black group-hover:before:transition-all group-hover:before:duration-300 group-hover:before:ease-in"></div>
                                                        <div className="group-hover:after:content-['+'] group-hover:after:absolute group-hover:after:top-0 group-hover:after:text-2xl group-hover:after:text-center group-hover:after:text-white group-hover:after:flex group-hover:after:items-center group-hover:after:justify-center group-hover:after:h-full group-hover:after:w-full"></div>
                                                    </Link>
                                                </div>
                                                <div className="lg:col-span-8 col-span-12 group-hover:text-[#1b5df3]">
                                                    <Link className="relative group" href={process.env.APP_URL+item?.link}>
                                                        <h3 className="cursor-pointer text-left line-clamp-1 text-lg leading-6 font-semibold mb-0 group-hover:text-[#1b5df3]">{item?.title}</h3>
                                                    </Link>
                                                    <p className="mb-1 overflow-hidden text-left line-clamp-2">{item?.description}</p>
                                                    <Link href={process.env.APP_URL+item?.link} className="mt-0 text-sm hover:text-[#1b5df3]">Know More <i className='fa fa-arrow-right hidden lg:block pr-6 text-sm group-hover:animation-[ease-in-out] group-hover:animation-[infinite]'></i></Link>
                                                </div>
                                            </div>
                                            </>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </section>
                    ))}
                </>
            }
        </>
    );
}

export default CaseStudiesSection
